import { call, put, select } from 'redux-saga/effects';

import { goToModelsService } from './router';
import {
  createModelRequest,
  deleteModelRequest,
  updateModelRequest,
  fetchModelsRequest,
} from '../requests';
import { pathSelector } from '../../../selectors';
import { createModel, deleteModel, updateModel } from '../../../actions';

export function* createModelService(data) {
  yield put(createModel(data));

  const { success } = yield call(createModelRequest, data);

  if (success) {
    yield call(fetchModelsRequest);
    yield call(goToModelsService);
  }
}

export function* updateModelService(id, data) {
  yield put(updateModel(id, data));
  yield call(updateModelRequest, id, data);
}

export function* updateCurrentModelService(data) {
  const { modelId } = yield select(pathSelector);

  yield call(updateModelService, modelId, data);
}

export function* deleteModelService(id) {
  const { modelId } = yield select(pathSelector);

  if (id === modelId) {
    yield call(goToModelsService);
  }

  yield put(deleteModel(id));
  yield call(deleteModelRequest, id);
}

export function* deleteCurrentModelService() {
  const { modelId } = yield select(pathSelector);

  yield call(deleteModelService, modelId);
}
